import {
  ManagementCard,
  ManagementCardAction,
  ManagementCardList,
  Pill,
} from 'components/ManagementCard'
import {
  commonStrings,
  headerStrings,
  organizationManagementStrings,
} from 'constants/strings'
import { useCopyToClipboard } from 'hooks/useCopyToClipboard'
import type { TOrganization } from 'types'
import { buildEntryUrl } from 'utils/buildEntryUrl'

type OrganizationsCardListProps = {
  organizations: TOrganization[]
  loading: boolean
  emptyMessage?: string
  onEdit?: (organizationId: number) => void
  className?: string
}

export function OrganizationsCardList({
  organizations,
  loading,
  emptyMessage = organizationManagementStrings.states.empty,
  onEdit,
  className,
}: OrganizationsCardListProps) {
  return (
    <ManagementCardList
      loading={loading}
      isEmpty={organizations.length === 0}
      loadingMessage={commonStrings.loading}
      emptyMessage={emptyMessage}
      className={className}
    >
      {organizations.map((organization) => (
        <li key={organization.id}>
          <ManagementCard
            onClick={onEdit ? () => onEdit(organization.id) : undefined}
            ariaLabel={`${organization.name} ${commonStrings.actions.edit}`}
            title={organization.name}
            badges={
              <Pill tone="neutral" className="ml-auto">
                {organizationManagementStrings.planLabels[organization.plan]}
              </Pill>
            }
            actions={
              organization.entryKey ? (
                <CopyEntryUrlAction entryKey={organization.entryKey} />
              ) : undefined
            }
          />
        </li>
      ))}
    </ManagementCardList>
  )
}

function CopyEntryUrlAction({ entryKey }: { entryKey: string }) {
  const { status, copy } = useCopyToClipboard()

  return (
    <ManagementCardAction
      icon={status === 'success' ? 'check' : 'link'}
      disabled={status !== 'idle'}
      onClick={() => copy(buildEntryUrl(entryKey))}
    >
      {status === 'success'
        ? headerStrings.copyEntryUrlSuccess
        : headerStrings.copyEntryUrl}
    </ManagementCardAction>
  )
}
